import {
  basenameForTeamsBrandedExpApp,
  basenameForWebApp,
  isLoadedWithEngageDomain,
  isLoadedWithGlammerDomain,
} from '@ms/yammer-web-support/dist/location';
import { isInMetaOsHub } from '@ms/yammer-web-support/dist/metaOsHub';
import { escapeRegExp } from 'lodash';

type RedirectToWebAppIfNecessary = () => Promise<boolean>;
export const redirectToWebAppIfNecessary: RedirectToWebAppIfNecessary = async () => {
  const hasBrowserSupport = process.env.ENABLE_BROWSER_SUPPORT === 'true';
  const shouldRedirectToWebApp =
    !hasBrowserSupport && (isLoadedWithGlammerDomain() || isLoadedWithEngageDomain()) && !(await isInMetaOsHub());

  if (!shouldRedirectToWebApp) {
    return false;
  }

  const basenameExp = new RegExp(`^${escapeRegExp(basenameForTeamsBrandedExpApp)}`);

  const redirectUrl = new URL(window.location.href);
  redirectUrl.pathname = redirectUrl.pathname.replace(basenameExp, basenameForWebApp);

  window.location.assign(redirectUrl.href);

  return true;
};
